// extracted by mini-css-extract-plugin
export default {"container":"TabInput_container__99yZf","item":"TabInput_item__2SIeH","itemActive":"TabInput_itemActive__iTtJh"};